import React, { useState } from 'react';
import { Alert, Box, Chip, IconButton, Paper, Stack, Typography } from '@mui/material';
import { BalanceRounded, CloseRounded, GavelRounded } from '@mui/icons-material';
import IntakeWizardCanadianCriminal from './IntakeWizardCanadianCriminal';
import IntakeWizardCanadianCivil from './IntakeWizardCanadianCivil';
import { firmProfile } from '../edition';

const PATHS = [
  {
    id: 'civil',
    icon: <BalanceRounded />,
    title: 'A dispute, claim or civil problem',
    detail: 'Small Claims, collections, LTB, employment or contractor, construction payment, human rights and permitted tribunal work.',
  },
  {
    id: 'criminal',
    icon: <GavelRounded />,
    title: 'A charge, offence or criminal problem',
    detail: 'Ontario provincial offences and permitted summary matters, with scope verified before a retainer.',
  },
];

export default function IntakeWizardUnified({ onClose, onSubmit, professionals = [] }) {
  const [matterType, setMatterType] = useState('');

  if (!matterType) {
    return (
      <Box sx={{ minHeight: '100%', bgcolor: 'background.default', p: { xs: 2, sm: 3, md: 4 } }}>
        <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
          <Box>
            <Chip label="NEO GUIDED INTAKE" size="small" color="secondary" variant="outlined" />
            <Typography variant="h4" sx={{ mt: 1.4, fontSize: { xs: '1.65rem', sm: '2.125rem' } }}>What does the NEO client need help with?</Typography>
            <Typography color="text.secondary" sx={{ mt: 0.6, maxWidth: 680 }}>
              Start once. {firmProfile.displayName}’s conflict-first intake adapts the questions, scope checks, workflow and documents inside the same private matter.
            </Typography>
          </Box>
          <IconButton onClick={onClose} aria-label="Close intake"><CloseRounded /></IconButton>
        </Stack>

        <Stack spacing={1.5} sx={{ mt: { xs: 3, md: 4 }, maxWidth: 860 }}>
          {PATHS.map(path => (
            <Paper
              key={path.id}
              component="button"
              type="button"
              variant="outlined"
              onClick={() => setMatterType(path.id)}
              sx={{ p: { xs: 2, sm: 2.5 }, textAlign: 'left', cursor: 'pointer', bgcolor: 'background.paper', borderRadius: 3, color: 'inherit', font: 'inherit', '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' } }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <Box sx={{ width: 46, height: 46, flexShrink: 0, borderRadius: 2.5, bgcolor: 'primary.main', color: '#fff', display: 'grid', placeItems: 'center' }}>{path.icon}</Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="h6">{path.title}</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.35 }}>{path.detail}</Typography>
                </Box>
              </Stack>
            </Paper>
          ))}
        </Stack>

        <Alert severity="info" sx={{ mt: 3, maxWidth: 760 }}>
          NEO Legal is an Ontario paralegal professional corporation. Every inquiry requires professional scope, competence and forum review; work outside the permitted scope is recorded for referral or decline.
        </Alert>
      </Box>
    );
  }

  const Wizard = matterType === 'criminal' ? IntakeWizardCanadianCriminal : IntakeWizardCanadianCivil;
  return (
    <Box sx={{ height: '100%', minHeight: 0 }}>
      <Wizard
        professionals={professionals}
        onClose={onClose}
        onChangeMatterType={() => setMatterType('')}
        onSubmit={data => onSubmit({ ...data, matterType })}
      />
    </Box>
  );
}
